import {isNoU, removeExtension} from "../../utils/DBUtils";

/**
 * Fills in default data from a file picked with FileStack into the given image data.
 * @param imageData
 * @param fileData
 * @return {*}
 */
export const fillImageDataFromFile = (imageData, fileData) => {
    if (isNoU(imageData.name)) {
        imageData.name = removeExtension(fileData.filename)
    }
    if (isNoU(imageData.filename)) {
        imageData.filename = fileData.filename;
    }
    return imageData;
};

export const imagesNamedFilters = Object.freeze([
  'image_type_original'
]);

export const imagesFilterGroups = Object.freeze([
  imagesNamedFilters
]);



// WEBPACK FOOTER //
// ./public/pages/Images/utils.js